import { Component, OnInit, ViewChild } from '@angular/core';
import { homeType } from 'app/core/data/home.json';
import { selectForm } from 'app/core/interfaces/authorization.types';
import { FormDirective } from 'app/core/directives/form-directive';
import { BaseComponent } from 'app/modules/shared/components/base.component';

export interface FormComponent {
  data: any;
}

@Component({
  selector: 'page-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent extends BaseComponent implements OnInit {
  public tipos: selectForm[] = homeType;
  public userName = '';

  @ViewChild(FormDirective, { static: true }) formHost!: FormDirective;

  ngOnInit() {
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['login']);
    }
    this.currentUser = this.auth.currentUserValue;
    if (this.currentUser) {
      if (this.currentUser.user && this.currentUser.user.name) {
        this.userName = this.currentUser.user.name;
      }

      if (this.checkIfFirstAcess()) {
        this.redirectFirstAccess();
        this.openSnackBar(
          'Olá! Que bom ter você no Posso Agendar. Finalize o cadastro do seu perfil para liberar todas as funcionalidades e ter a melhor experiência.',
          'warning',
        );
        return;
      }

      this.loadComponent(this.currentUser.type);
    }
  }

  loadComponent(tipo: string) {
    const formItem = this.tipos.find((item: selectForm) => item.id == tipo);

    if (formItem?.component) {
      const viewContainerRef = this.formHost.viewContainerRef;
      viewContainerRef.clear();

      const componentRef = viewContainerRef.createComponent<FormComponent>(formItem.component);
      componentRef.instance.data = {};
    }
  }

  checkIfFirstAcess() {
    const firstAccess = localStorage.getItem('isFirstAccess');
    return firstAccess === 'true';
  }

  redirectFirstAccess() {
    const actor = localStorage.getItem('userType');

    switch (actor) {
      case 'organization':
        this.router.navigate(['organization-new/meus-dados']);
        break;
      case 'secretary':
        this.router.navigate(['secretarias-new/meus-dados']);
        break;
      case 'practitioner':
        this.router.navigate(['medico/meus-dados']);
        break;
      default:
        this.router.navigate(['patient-new/meus-dados']);
        break;
    }
  }
}
